import React from "react";
import { map } from "lodash";
import { OverlayTrigger, Popover } from "react-bootstrap";
import "./ActionsMenu.scss";

interface ActionsMenuAction {
  label?: string;
  onClick: () => void;
  icon?: React.ReactNode;
}

interface ActionsMenuProps {
  actions?: ActionsMenuAction[];
  // OverlayTrigger requires a single element (or render fn) as its trigger child.
  children: React.ReactElement;
}

function buildPopover(actions: ActionsMenuAction[]) {
  return (
    <Popover className="action-list-popover">
      <Popover.Body>
        <ul className="actions-list">
          {map(actions, (action) => {
            return (
              <li
                key={action.label}
                className="action-item"
                onClick={() => {
                  action.onClick();
                  // close overlay manually
                  document.body.click();
                }}
              >
                {action.icon && (
                  <span className="action-icon">{action.icon}</span>
                )}
                <p>{action.label}</p>
              </li>
            );
          })}
        </ul>
      </Popover.Body>
    </Popover>
  );
}

const ActionsMenu = ({ actions = [], children }: ActionsMenuProps) => {
  const popover = buildPopover(actions);
  return (
    <div className="actions-menu">
      <OverlayTrigger
        rootClose
        trigger="click"
        placement="bottom"
        overlay={popover}
      >
        {children}
      </OverlayTrigger>
    </div>
  );
};

export default ActionsMenu;
